import ReactDom from "react-dom";

export default function reactDomContains(reactElementContainer, element) {
  const domElementContainer = ReactDom.findDOMNode(reactElementContainer);
  return (
    domElementContainer.contains(element) || domElementContainer === element
  );
}
